import React from 'react';
import {
  ButtonGroup,
  DropdownButton,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';

const initialState = {
  privilege: null,
  isShow: false,
};

const Action = ({ data }) => {
  const Session = useSelector((state) => state.Auth?.session);

  const [{ privilege }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (privilege?.action === 'manage' || !Session?.privileges) {
    if (data?.status === 'new') {
      return (
        <>
          <DropdownButton
            as={ButtonGroup}
            variant="transparent"
            size="md"
            className="no-carret tbl-action"
            title={<Fi.FiMoreVertical size={13} color="gray" />}
          >
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/manifest/receive/${data?.id}`}
            >
              <Fi.FiClipboard size={15} color="#202020" className="me-2" />
              Detil
            </Link>
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/manifest/${data?.id}/update`}
            >
              <Fi.FiEdit size={15} color="#202020" className="me-2" />
              Perbaharui
            </Link>

            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/print/manifest/${
                data?.type === 'sea_freight' || data?.type === 'air_freight'
                  ? 'console'
                  : data?.type
              }/${data?.id}`}
              target="_blank"
            >
              <Fi.FiPrinter size={15} color="#202020" className="me-2" />
              Print Manifest
            </Link>

            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/manifest/${data?.id}/update`}
            >
              <Fi.FiTrash2 size={15} color="#202020" className="me-2" />
              Hapus
            </Link>
          </DropdownButton>
        </>
      );
    } else {
      return (
        <>
          <DropdownButton
            as={ButtonGroup}
            variant="transparent"
            size="md"
            className="no-carret tbl-action"
            title={<Fi.FiMoreVertical size={13} color="gray" />}
          >
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/manifest/receive/${data?.id}`}
            >
              <Fi.FiClipboard size={15} color="#202020" className="me-2" />
              Detil
            </Link>
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/print/manifest/${
                data?.type === 'sea_freight' || data?.type === 'air_freight'
                  ? 'console'
                  : data?.type
              }/${data?.id}`}
              target="_blank"
            >
              <Fi.FiPrinter size={15} color="#202020" className="me-2" />
              Print Manifest
            </Link>
          </DropdownButton>
        </>
      );
    }
  }

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id={`tooltip-top`}>Detil</Tooltip>}
    >
      <Link
        className="btn btn-light px-2"
        role="button"
        to={`/manifest/receive/${data?.id}`}
      >
        <Fi.FiArrowRight />
      </Link>
    </OverlayTrigger>
  );
};

export default Action;
